import {
  Zap,
  Flame,
  BatteryCharging,
  Building2,
  Factory,
  Hotel,
  HeartPulse,
  Warehouse,
  Server,
  ReceiptText,
  LineChart,
  TrendingUp,
  MapPin,
  BookMarked,
  BookOpen,
  FileText,
  GraduationCap,
  Gauge,
  Layers,
  Landmark,
  Handshake,
} from "lucide-react";

const MAP = {
  Zap,
  Flame,
  BatteryCharging,
  Building2,
  Factory,
  Hotel,
  HeartPulse,
  Warehouse,
  Server,
  ReceiptText,
  LineChart,
  TrendingUp,
  MapPin,
  BookMarked,
  BookOpen,
  FileText,
  GraduationCap,
  Gauge,
  Layers,
  Landmark,
  Handshake,
};

export default function ServiceIcon({ name, className }) {
  const Icon = MAP[name] || Zap;
  return <Icon className={className} />;
}
